var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkUploadSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C7.178 32 0 24.822 0 16C0 7.178 7.178 0 16 0C24.822 0 32 7.178 32 16C32 24.822 24.822 32 16 32ZM14.9999 21C14.7349 21 14.4809 20.895 14.2929 20.707L10.2929 16.707C9.90188 16.316 9.90188 15.684 10.2929 15.293C10.6839 14.902 11.3159 14.902 11.7069 15.293L14.9509 18.537L21.2469 11.341C21.6119 10.924 22.2429 10.883 22.6579 11.247C23.0739 11.611 23.1159 12.242 22.7529 12.658L15.7529 20.658C15.5709 20.867 15.3109 20.99 15.0339 20.999C15.0219 21 15.0109 21 14.9999 21ZM2 16C2 8.28 8.28 2 16 2C23.72 2 30 8.28 30 16C30 23.72 23.72 30 16 30C8.28 30 2 23.72 2 16Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C7.178 32 0 24.822 0 16C0 7.178 7.178 0 16 0C24.822 0 32 7.178 32 16C32 24.822 24.822 32 16 32ZM14.9999 21C14.7349 21 14.4809 20.895 14.2929 20.707L10.2929 16.707C9.90188 16.316 9.90188 15.684 10.2929 15.293C10.6839 14.902 11.3159 14.902 11.7069 15.293L14.9509 18.537L21.2469 11.341C21.6119 10.924 22.2429 10.883 22.6579 11.247C23.0739 11.611 23.1159 12.242 22.7529 12.658L15.7529 20.658C15.5709 20.867 15.3109 20.99 15.0339 20.999C15.0219 21 15.0109 21 14.9999 21ZM2 16C2 8.28 8.28 2 16 2C23.72 2 30 8.28 30 16C30 23.72 23.72 30 16 30C8.28 30 2 23.72 2 16Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#15CD93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkUploadSuccess);
export default __webpack_public_path__ + "static/media/checkmark-upload-success.53e1ebaee62aba7fe015dad5ddf3833d.svg";
export { ForwardRef as ReactComponent };